import * as React from "react";
import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import ComponentLinkLabelModel from "./ComponentLinkLabelModel";
import ComponentLinkLabelWidget from "./ComponentLinkLabelWidget";

export default class ComponentLinkLabelFactory extends AbstractReactFactory {
  constructor() {
    super("component-link-label");
  }

  generateModel() {
    return new ComponentLinkLabelModel();
  }

  generateReactWidget(event) {
    return <ComponentLinkLabelWidget model={event.model} engine={this.engine} />;
  }
}
